import type { OrderInfo } from '@@partner:types:app'

import React, { useState, useMemo } from 'react'
import { SelectPicker } from 'rsuite'

import KanbanColumn from './KanbanColumn'
import { sortOrders, SORT_OPTIONS, SortOption } from './kanbanHelpers'
import type { KanbanStatusGroup } from './kanbanHelpers'

import './KanbanBoard.scss'

export interface KanbanBoardProps {
  brandSlug: string
  ordersByGroup: Map<string, OrderInfo[]>
  loading?: boolean
  groups: KanbanStatusGroup[]
}

export default function KanbanBoard ({
  brandSlug,
  ordersByGroup,
  loading,
  groups
}: KanbanBoardProps) {
  const [ sortBy, setSortBy ] = useState<SortOption>('slot_time')

  // Сортируем заказы в каждой колонке
  const sortedOrdersByGroup = useMemo(() => {
    const sorted = new Map<string, OrderInfo[]>()
    groups.forEach(group => {
      const orders = ordersByGroup.get(group.key) || []
      sorted.set(group.key, sortOrders(orders, sortBy))
    })
    return sorted
  }, [ ordersByGroup, groups, sortBy ])

  return (
    <div className="KanbanBoard">
      <div className="KanbanBoard__Header">
        <SelectPicker
          data={SORT_OPTIONS}
          value={sortBy}
          onChange={(value) => setSortBy(value as SortOption)}
          cleanable={false}
          searchable={false}
          size="xs"
          style={{ width: 180 }}
          placeholder="Сортировка"
        />
      </div>
      <div className="KanbanBoard__Columns">
        {groups.map(group => {
          const orders = sortedOrdersByGroup.get(group.key) || []

          return (
            <KanbanColumn
              key={group.key}
              brandSlug={brandSlug}
              label={group.label}
              orders={orders}
              loading={loading}
            />
          )
        })}
      </div>
    </div>
  )
}
